import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=5530227d&scoped=true"
import script from "./Properties.vue?vue&type=script&lang=js"
export * from "./Properties.vue?vue&type=script&lang=js"
import style0 from "./Properties.vue?vue&type=style&index=0&id=5530227d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5530227d",
  null
  
)

export default component.exports